import { FC } from 'react';
import { PriceCard, type PriceCardProps } from './price-card';
import style from './price-card.module.scss';

export interface PriceCardDeckProps {
  items: PriceCardProps[];
}

const PriceCardDeck: FC<PriceCardDeckProps> = ({ items }) => {
  return (
    <div
      className={style.deck}
      style={{ gridTemplateColumns: `repeat(${items.length}, 1fr)` }}
    >
      {items.map((item) => (
        <PriceCard key={item.label} {...item} />
      ))}
    </div>
  );
};

export { PriceCardDeck };
